// @flow
import * as React from 'react';
import { art, asian, collectibles, fashion, furniture, home, jewelry, memorabilia } from './megaNavLinks';
import { getMegaNavImageUrlLarge, getMegaNavImageUrlSmall } from '../../../utils/urls';
import FindAuctions from './FindAuctions';
import isEqual from 'react-fast-compare';
import LinkContainer from './LinkContainer';
import MegaNavLink from './MegaNavLink';
import noop from '../../../utils/noop';
import styles from './Navigation.module.scss';

type Props = {
    mobile: string,
    parent: any,
    trackPastAuctionResultsClick: Function,
};

type State = {
    active: number,
};

export default class Navigation extends React.Component<Props, State> {
    static defaultProps = {
        parent: false,
    };

    state = { active: 0 };

    componentDidMount() {
        window.addEventListener('touchstart', this.handleClickOutside, false);
    }

    shouldComponentUpdate = (nextProps: Props, nextState: State) =>
        !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);

    componentWillUnmount() {
        window.removeEventListener('touchstart', this.handleClickOutside, false);
    }

    wrapper: ?HTMLDivElement;

    handleClickOutside = (event: SyntheticTouchEvent<>) => {
        if (this.props.mobile === 'tablet') {
            if (this.wrapper && this.wrapper.contains && !this.wrapper.contains((event.currentTarget: any))) {
                this.closeNav();
            }
        }
    };

    openNav = (key: number) => {
        return () => {
            this.setState({ active: key });
        };
    };

    closeNav = () => {
        if (this.state.active) {
            this.setState({ active: 0 });
        }
    };

    tabletNavigation = (link: string, key: number) => {
        return () => {
            if (this.state.active !== key) {
                this.setState({ active: key });
            } else {
                window.location.assign(link);
                this.setState({ active: 0 });
            }
        };
    };

    render() {
        const { mobile, parent, trackPastAuctionResultsClick } = this.props;

        const { active } = this.state;
        const isPhone = mobile && mobile !== 'tablet';
        return (
            <div className={styles.wrapper} ref={ref => (this.wrapper = ref)}>
                <div className={styles.navigation} onMouseLeave={!mobile ? this.closeNav : noop}>
                    <div className={styles['scroll-container']}>
                        <FindAuctions parent={parent} trackPastAuctionResultsClick={trackPastAuctionResultsClick} />
                        <div className={`${styles.item} ${styles.pipe}`}>|</div>
                        <div className={styles.navBar}>
                            <MegaNavLink
                                active={active === 1}
                                closeNav={this.closeNav}
                                mobile={mobile}
                                openNav={this.openNav(1)}
                                tabletNavigation={this.tabletNavigation('/c/art/1/', 1)}
                                link="/c/art/1/"
                                msgId="navigation.art"
                            />
                            <MegaNavLink
                                active={active === 2}
                                closeNav={this.closeNav}
                                mobile={mobile}
                                openNav={this.openNav(2)}
                                tabletNavigation={this.tabletNavigation('/c/jewelry/6/', 2)}
                                link="/c/jewelry/6/"
                                msgId="navigation.jewelry"
                            />
                            <MegaNavLink
                                active={active === 3}
                                closeNav={this.closeNav}
                                mobile={mobile}
                                openNav={this.openNav(3)}
                                tabletNavigation={this.tabletNavigation('/c/asian/158/', 3)}
                                link="/c/asian/158/"
                                msgId="navigation.asian_antiques"
                            />
                            <MegaNavLink
                                active={active === 4}
                                closeNav={this.closeNav}
                                mobile={mobile}
                                openNav={this.openNav(4)}
                                tabletNavigation={this.tabletNavigation('/c/furniture/4/', 4)}
                                link="/c/furniture/4/"
                                msgId="navigation.furniture"
                            />
                            <MegaNavLink
                                active={active === 5}
                                closeNav={this.closeNav}
                                mobile={mobile}
                                openNav={this.openNav(5)}
                                tabletNavigation={this.tabletNavigation('/c/collectibles/2/', 5)}
                                link="/c/collectibles/2/"
                                msgId="navigation.collectibles"
                            />
                            <MegaNavLink
                                active={active === -1}
                                openNav={this.openNav(0)}
                                mobile={mobile}
                                closeNav={this.closeNav}
                                tabletNavigation={this.tabletNavigation('/c/coins-currency-stamps/24/', 0)}
                                link="/c/coins-currency-stamps/24/"
                                msgId="navigation.coins"
                            />
                            <MegaNavLink
                                active={active === 6}
                                closeNav={this.closeNav}
                                mobile={mobile}
                                openNav={this.openNav(6)}
                                tabletNavigation={this.tabletNavigation('/c/memorabilia/26429/', 6)}
                                link="/c/memorabilia/26429/"
                                msgId="navigation.memorabilia"
                            />
                            <MegaNavLink
                                active={active === 7}
                                closeNav={this.closeNav}
                                mobile={mobile}
                                openNav={this.openNav(7)}
                                tabletNavigation={this.tabletNavigation('/c/home-garden/5/', 7)}
                                link="/c/home-garden/5/"
                                msgId="navigation.home_and_garden"
                            />
                            <MegaNavLink
                                active={active === 8}
                                closeNav={this.closeNav}
                                mobile={mobile}
                                openNav={this.openNav(8)}
                                tabletNavigation={this.tabletNavigation('/c/fashion/3/', 8)}
                                link="/c/fashion/3/"
                                msgId="navigation.fashion"
                            />
                        </div>
                    </div>
                    {!isPhone && (
                        <div>
                            <LinkContainer
                                active={active === 1}
                                closeNav={this.closeNav}
                                mobile={mobile}
                                linkArray={art}
                                picLinkS={getMegaNavImageUrlSmall('art')}
                                picLinkL={getMegaNavImageUrlLarge('art')}
                            />
                            <LinkContainer
                                active={active === 2}
                                closeNav={this.closeNav}
                                mobile={mobile}
                                linkArray={jewelry}
                                picLinkS={getMegaNavImageUrlSmall('jewelry')}
                                picLinkL={getMegaNavImageUrlLarge('jewelry')}
                            />
                            <LinkContainer
                                active={active === 3}
                                closeNav={this.closeNav}
                                mobile={mobile}
                                linkArray={asian}
                                picLinkS={getMegaNavImageUrlSmall('asian')}
                                picLinkL={getMegaNavImageUrlLarge('asian')}
                            />
                            <LinkContainer
                                active={active === 4}
                                closeNav={this.closeNav}
                                mobile={mobile}
                                linkArray={furniture}
                            />
                            <LinkContainer
                                active={active === 5}
                                closeNav={this.closeNav}
                                mobile={mobile}
                                linkArray={collectibles}
                                picLinkS={getMegaNavImageUrlSmall('collectibles')}
                                picLinkL={getMegaNavImageUrlLarge('collectibles')}
                            />
                            <LinkContainer
                                active={active === 6}
                                closeNav={this.closeNav}
                                mobile={mobile}
                                linkArray={memorabilia}
                                picLinkS={getMegaNavImageUrlSmall('memorabilia')}
                                picLinkL={getMegaNavImageUrlLarge('memorabilia')}
                            />
                            <LinkContainer
                                active={active === 7}
                                closeNav={this.closeNav}
                                mobile={mobile}
                                linkArray={home}
                            />
                            <LinkContainer
                                active={active === 8}
                                closeNav={this.closeNav}
                                mobile={mobile}
                                linkArray={fashion}
                                picLinkS={getMegaNavImageUrlSmall('fashion')}
                                picLinkL={getMegaNavImageUrlLarge('fashion')}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
